// eslint-disable-next-line no-restricted-imports

import { TabsStyled } from './Tabs.styles';
import { TabsProps } from './types';

/**
 * Tabs component.
 */
export const Tabs = (props: TabsProps) => (
  <TabsStyled datax="tabs" {...props} />
);
